import { defineStore } from 'pinia'

/**
 * @typedef {{ type: string, key: string, position: number }} NavItem
 */

export const useNavConfigStore = defineStore('navConfig', {
  state: () => ({
    /** @type {NavItem[]} */
    positions: [],
  }),

  getters: {
    /**
     * @param {object} state
     * @returns {(type: string, key: string) => number}
     */
    positionFor: (state) => (type, key) => {
      const item = state.positions.find(
        (p) => p.type === type && p.key === String(key),
      )
      return item?.position ?? Infinity
    },
  },

  actions: {
    async FETCH_NAV_CONFIG ({ orgCanonical }) {
      try {
        const { data } = (await this.$cycloid.ydAPI.getOrgNav(orgCanonical)) || {}
        this.positions = data?.items ?? []
      } catch (_err) {
        this.positions = []
      }
    },

    async SAVE_NAV_CONFIG ({ orgCanonical, items }) {
      const { data, errors } = (await this.$cycloid.ydAPI.putOrgNav(orgCanonical, { items })) || {}
      if (errors?.length) throw new Error(errors[0].message)
      this.positions = data?.items ?? []
    },
  },
})
